import {chain2} from "@Common/utils/fs";

import {addVector}      from "./add-vector";
import {centerOfSize}   from "./center-of-size";
import {rotatePoint}    from "./rotate-point";
import {subtractVector} from "./subtract-vector";
import {multiplyVector} from "@Common/ui-components/image-editor/common/multiply-vector";

export const getImgPoint2 = (vpSize, image, rawSize) => {

    const c1 = centerOfSize(vpSize);
    const c2 = image.center ?? centerOfSize(rawSize);

    const chainFns = [
        (_) => subtractVector(_, c1), // To center of vp, which is also the future center of image
        (_) => multiplyVector(_, 1 / image.scale),

        (_) => rotatePoint(_, -image.rotation),
        (_) => !image.flip ? _ : {x: -_.x, y: _.y},

        (_) => addVector(_, c2),
    ];

    return (p) => chain2(p, chainFns);
};


